<script lang="ts">
    import {link} from "svelte-spa-router";
</script>


<div class="banner_container mt-5">
    <h1 class="has-text-centered"><a href="/" use:link ><img class="banner_logo" src="assets/img/logo_chrono.png" alt="logo chronochape"></a></h1>
</div>